/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EmailIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EmailIcon({
  children,
  viewPath = "/DesignSystem/Svgs/EmailIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="EmailIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-Zcl1xM': alignSelf,'--mt-2-Zcl1xM': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zcl1xM': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zcl1xM': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zcl1xM': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zcl1xM': opacity,'--w-10-Zcl1xM': typeof width === 'number' ? `${width}px` : width,'--h-11-Zcl1xM': typeof height === 'number' ? `${height}px` : height,'--a-7-Zcl1xM': isAnimated ? animation : "none",'--sd-8-Zcl1xM': isAnimated ? strokeDashoffset : 0,'--sd-9-Zcl1xM': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="EmailIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M26.1 25.4H5.9c-1.6 0-2.8-1.3-2.8-2.8V9.4c0-1.6 1.3-2.8 2.8-2.8h20.3c1.6 0 2.8 1.3 2.8 2.8v13.2c0 1.6-1.3 2.8-2.9 2.8z"
 style={{'--f-12-Zcl1xM': fill,'--s-13-Zcl1xM': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="EmailIcon.SvgPath:1"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M28.3 6.9L16 19.1 3.7 6.9M18.4 14.7L28.7 25M3.3 25l10.3-10.3"
 style={{'--f-12-Zcl1xM': fill,'--s-13-Zcl1xM': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}